Human readable descriptions of the remuneration package.

Scheme requirements:

- The `seekAnz` scheme is limited to a single element with a maximum length of 50 characters.

An empty array must be provided to signify the absence of salary descriptions.
